import { render } from "./DatosPersonales.vue?vue&type=template&id=2c0d21db"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"

import "./DatosPersonales.vue?vue&type=style&index=0&id=2c0d21db&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__